module.exports = __webpack_public_path__ + "img/order-delivered.b8606b0d.gif";